import { useState } from 'react';
import { Icon } from './Icon';

/** 격자 / 목록 보기 (R1-8 · 컨셉 §7.5) — 검색 결과와 전체 원단이 함께 쓴다. 선택은 localStorage('aitex.view'). */
export type View = 'grid' | 'list';
const VIEW_KEY = 'aitex.view';

function readView(): View {
  try { return localStorage.getItem(VIEW_KEY) === 'list' ? 'list' : 'grid'; } catch { return 'grid'; }
}

/** 저장소가 막혀도 이번 화면에서는 바뀐다 */
export function useView(): [View, (v: View) => void] {
  const [view, setView] = useState<View>(readView);
  const pick = (v: View) => {
    setView(v);
    try { localStorage.setItem(VIEW_KEY, v); } catch { /* 저장만 못 한다 */ }
  };
  return [view, pick];
}

export default function ViewToggle({ view, onChange }: { view: View; onChange: (v: View) => void }) {
  return (
    <div className="view-toggle" role="group" aria-label="보기 방식">
      <button type="button" className="icon-btn" aria-pressed={view === 'grid'}
              aria-label="격자로 보기" title="격자로 보기" onClick={() => onChange('grid')}>
        <Icon name="grid" size={18} />
      </button>
      <button type="button" className="icon-btn" aria-pressed={view === 'list'}
              aria-label="목록으로 보기" title="목록으로 보기" onClick={() => onChange('list')}>
        <Icon name="list" size={18} />
      </button>
    </div>
  );
}
